import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Card, CardBody } from "reactstrap";

import moment from "moment";
import { useSelector } from "react-redux";
import {
  authKey_local_storage_key,
  convertToSlug,
  getCompanyLogo,
  getJobExperiences,
  getSalaryAmount,
  isValidURL,
  redirect_url_key,
  showErrorMessage,
} from "../../../helpers/common";
import AddToBookmarkJob from "../../../helpers/Common/AddToBookmarkJob";
import ApplyJobModal from "../../../helpers/Common/ApplyJobModal";

const RightSideContent = ({ details }) => {
  //Apply for Job Model
  const [applyJobModal, setApplyJobModal] = useState(false);
  const [currJob, setCurrJob] = useState({});

  const authToken = localStorage.getItem(authKey_local_storage_key);

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const openApplyJobModal = (e, jobDetails) => {
    e.preventDefault();

    if (authToken) {
      setApplyJobModal(!applyJobModal);
      setCurrJob(jobDetails);
    } else {
      showErrorMessage("You need to login first.");

      localStorage.setItem(redirect_url_key, pathname);
      navigate("/signin");
    }
  };
  const customer = useSelector((state) => state.customer.profile);

  const companyDetails = details.company;

  const companyDetailPageUrl = companyDetails
    ? `/company/details/${companyDetails?.id}/${convertToSlug(
        companyDetails?.name || "",
      )}`
    : "#";

  const candidateReducer = useSelector((state) => state.candidate);
  const appliedJobs = candidateReducer.jobApplications;

  // Pehle check karein ki appliedJobs ke andar 'data' array hai ya nahi
  const isAppliedJob = Array.isArray(appliedJobs?.data)
    ? appliedJobs.data.find((item) => item?.job?.id === details?.id)
    : null;

  return (
    <React.Fragment>
      <div className="side-bar ms-lg-4">
        <Card className="company-profile border-0 shadow-lg rounded-4">
          <CardBody className="p-4 p-lg-5">
            <div className="text-center">
              <div
                className="mx-auto d-flex align-items-center justify-content-center bg-white border rounded-4 shadow-sm overflow-hidden"
                style={{
                  width: "170px",
                  height: "170px",
                  borderRadius: "25px",
                }}
              >
                <img
                  src={getCompanyLogo(companyDetails?.logo)}
                  alt={companyDetails?.name}
                  className="img-fluid"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",

                    padding: "10px",
                  }}
                />
              </div>

              <div className="mt-4">
                <h5 className="fw-bold mb-1">{companyDetails?.name}</h5>

                <span className="badge bg-soft-primary text-primary px-3 py-2 rounded-pill">
                  Since {companyDetails?.establishmentYear}
                </span>
              </div>
            </div>
            <ul className="list-unstyled mt-4">
              {/* <li>
                <div className='d-flex'>
                  <i className='uil uil-phone-volume text-primary fs-4'></i>
                  <div className='ms-3'>
                    <h6 className='fs-14 mb-2'>Phone</h6>
                    <a
                      className='primary-link text-muted fs-14 mb-0'
                      href={`tel:${companyDetails?.contact_number}`}
                    >
                      {companyDetails?.contact_number}
                    </a>
                  </div>
                </div>
              </li> */}
              {/* <li className='mt-3'>
                <div className='d-flex'>
                  <i className='uil uil-envelope text-primary fs-4'></i>
                  <div className='ms-3'>
                    <h6 className='fs-14 mb-2'>Email</h6>
                    <a
                      className='primary-link text-muted fs-14 mb-0'
                      href={`mailto:${companyDetails?.email_address}`}
                    >
                      {companyDetails?.email_address}
                    </a>
                  </div>
                </div>
              </li> */}
              {companyDetails?.website_url && (
                <li className="mt-3">
                  <div className="d-flex">
                    <i className="uil uil-globe text-primary fs-4"></i>
                    <div className="ms-3">
                      <h6 className="fs-14 mb-2">Website</h6>
                      <a
                        className="primary-link text-muted fs-14 mb-0"
                        href={`${companyDetails?.website_url}`}
                      >
                        {companyDetails?.website_url}
                      </a>
                    </div>
                  </div>
                </li>
              )}
              <li className="mt-3">
                <div className="d-flex">
                  <i className="uil uil-map-marker text-primary fs-4"></i>

                  <div className="ms-3">
                    <h6 className="fs-14 mb-2">Location</h6>

                    <p className="text-muted fs-14 mb-0">
                      {details?.location
                        ? `${details.location.name}, ${details.location.state}`
                        : "India"}
                    </p>
                  </div>
                </div>
              </li>
            </ul>
            <div className="mt-4">
              {companyDetails ? (
                <Link
                  to={companyDetailPageUrl}
                  className="btn btn-primary btn-hover w-100 rounded"
                >
                  <i className="mdi mdi-eye"></i> View Profile
                </Link>
              ) : (
                <button className="btn btn-primary w-100 rounded" disabled>
                  Loading Profile...
                </button>
              )}
            </div>
          </CardBody>
        </Card>
        <Card className="job-overview mt-5">
          <CardBody className="p-4">
            <h6 className="fs-17">Job Overview</h6>
            <ul className="list-unstyled mt-4 mb-0">
              <li>
                <div className="d-flex mt-4">
                  <i className="uil uil-file-alt icon bg-soft-primary"></i>
                  <div className="ms-3">
                    <h6 className="fs-14 mb-2">Job Title</h6>
                    <p className="text-muted mb-0">{details.jobTitle}</p>
                  </div>
                </div>
              </li>
              <li>
                <div className="d-flex mt-4">
                  <i className="uil uil-briefcase icon bg-soft-primary"></i>
                  <div className="ms-3">
                    <h6 className="fs-14 mb-2">Job Vacancies</h6>
                    <p className="text-muted mb-0">
                      {details.totalNumberOfVacancies}
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div className="d-flex mt-4">
                  <i className="uil uil-star-half-alt icon bg-soft-primary"></i>
                  <div className="ms-3">
                    <h6 className="fs-14 mb-2">Experience</h6>
                    <p className="text-muted mb-0">
                      {getJobExperiences(details)}
                    </p>
                  </div>
                </div>
              </li>

              <li className="mt-3">
                <div className="d-flex">
                  <i className="uil uil-location-point icon bg-soft-primary"></i>

                  <div className="ms-3">
                    <h6 className="fs-14 mb-2">Location</h6>

                    <p className="text-muted fs-14 mb-0">
                      {details?.location
                        ? `${details.location.name}, ${details.location.state}`
                        : "India"}
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div className="d-flex mt-4">
                  <i className="uil uil-usd-circle icon bg-soft-primary"></i>
                  <div className="ms-3">
                    <h6 className="fs-14 mb-2">Salary</h6>
                    <p className="text-muted mb-0">
                      {(() => {
                        const salary = getSalaryAmount(details, "month", false);
                        return !salary || salary === "0" || salary === 0
                          ? "Not Disclosed"
                          : salary;
                      })()}
                    </p>
                  </div>
                </div>
              </li>
              {/* <li>
                <div className="d-flex mt-4">
                  <i className="uil uil-graduation-cap icon bg-soft-primary"></i>
                  <div className="ms-3">
                    <h6 className="fs-14 mb-2">Qualification</h6>
                    <p className="text-muted mb-0">Bachelor Degree</p>
                  </div>
                </div>
              </li> */}
              {/* <li>
                <div className="d-flex mt-4">
                  <i className="uil uil-building icon bg-soft-primary"></i>
                  <div className="ms-3">
                    <h6 className="fs-14 mb-2">Industry</h6>
                    <p className="text-muted mb-0">Private</p>
                  </div>
                </div>
              </li> */}
              <li>
                <div className="d-flex mt-4">
                  <i className="uil uil-history icon bg-soft-primary"></i>
                  <div className="ms-3">
                    <h6 className="fs-14 mb-2">Date Posted</h6>
                    <p className="text-muted mb-0">
                      Posted{" "}
                      {details?.createdAt
                        ? moment(
                            details.createdAt,
                            "YYYY-MM-DD HH:mm:ss",
                          ).fromNow()
                        : "N/A"}
                    </p>
                  </div>
                </div>
              </li>
            </ul>
            {customer?.customer_type !== 1 ? (
              <div className="mt-3">
                {isAppliedJob ? (
                  <Link
                    to="#applyNow"
                    className="btn btn-success btn-hover w-100 mt-2 disabled"
                  >
                    Already Applied <i className="mdi mdi-check"></i>
                  </Link>
                ) : (
                  <Link
                    to="#"
                    onClick={(e) => openApplyJobModal(e, details)}
                    className="btn btn-primary btn-hover w-100 mt-2"
                  >
                    Apply Now <i className="uil uil-arrow-right"></i>
                  </Link>
                )}

                <AddToBookmarkJob
                  size="lg"
                  jobDetails={details}
                  companyDetails={companyDetails}
                />
              </div>
            ) : null}
          </CardBody>
        </Card>

        {companyDetails?.map_location &&
        isValidURL(companyDetails?.map_location) ? (
          <div className="mt-4">
            <h6 className="fs-16 mb-3">Job location</h6>
            {companyDetails?.map_location &&
            isValidURL(companyDetails?.map_location) ? (
              <iframe
                src={companyDetails?.map_location}
                title="title"
                style={{ width: `100%`, height: `250` }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            ) : (
              <p>Job location not available right now.</p>
            )}
          </div>
        ) : null}

        <ApplyJobModal
          currJob={currJob}
          setApplyJobModal={setApplyJobModal}
          applyJobModal={applyJobModal}
        />
      </div>
    </React.Fragment>
  );
};

export default RightSideContent;
